import { IconBase } from './IconBase'

type IconNotificationProps = React.ComponentProps<'svg'>

export const IconNotification = (props: IconNotificationProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 12 12" {...props}>
      <circle cx="6" cy="6" r="6" fill="url(#paint0_linear_1132_156564)" />
      <path
        d="M7.83117 3L7.12987 6.90476L5.1039 3H4.08117L3 9H4.16883L4.87013 5.09524L6.8961 9H7.91883L9 3H7.83117Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1132_156564"
          x1="-5.9043e-08"
          y1="5.73915"
          x2="12"
          y2="5.73915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7575" />
          <stop offset="1" stopColor="#FFA800" />
        </linearGradient>
      </defs>
    </IconBase>
  )
}
